export const nightlife = {
  name: 'Nightlife',
  color: [1, 0, 0.2196078431372549, 1],
  bg: [0, 0.8117647058823529, 0.9803921568627451, 1],
  grid1: [0.9764705882352941, 0.8627450980392157, 0.1411764705882353, 1],
  grid2: [0.00784313725490196, 0.0196078431372549, 0.03529411764705882, 1],
}
